import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  FaUser, FaLock, FaRocket, FaHourglassHalf, FaShieldAlt, FaArrowLeft
} from 'react-icons/fa';
import { adminLogin } from '../utils/api';
import logo from '../images/logo.png';
import './AdminLogin.css';

const AdminLogin = () => {
  const [credentials, setCredentials] = useState({ username: '', password: '' });
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const handleChange = (e) => {
    setCredentials({ ...credentials, [e.target.name]: e.target.value });
    setError('');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setIsLoading(true);
    try {
      const data = await adminLogin(credentials.username, credentials.password);
      localStorage.setItem('admin_token', data.token);
      navigate('/admin/dashboard');
    } catch (err) {
      setError(err.message || 'Invalid username or password');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="admin-login">
      <div className="login-container">
        <div className="login-header">
          <div className="admin-logo-container">
            <img src={logo} alt="Loan Made Easy Logo" className="admin-login-logo" />
          </div>
          <h1>Admin Portal</h1>
          <p>Secure access to loan management dashboard</p>
        </div>

        {error && <p className="error-message">{error}</p>}

        <form onSubmit={handleSubmit}>
          <div>
            <label><FaUser style={{ marginRight: 8 }} /> Username:</label>
            <input
              type="text" name="username" value={credentials.username}
              onChange={handleChange} placeholder="Enter admin username" required
            />
          </div>
          <div>
            <label><FaLock style={{ marginRight: 8 }} /> Password:</label>
            <input
              type="password" name="password" value={credentials.password}
              onChange={handleChange} placeholder="Enter admin password" required
            />
          </div>

          <div className="button-group">
            <button type="submit" className="primary-btn" disabled={isLoading}>
              {isLoading
                ? <><FaHourglassHalf style={{ marginRight: 8 }} /> Logging in...</>
                : <><FaRocket style={{ marginRight: 8 }} /> Login</>}
            </button>
            <button
              type="button" className="secondary-btn"
              onClick={() => navigate('/login')}
            >
              <FaArrowLeft style={{ marginRight: 8 }} /> User Login
            </button>
          </div>
        </form>

        <div className="login-footer">
          <p><FaShieldAlt style={{ marginRight: 8 }} /> Secure login with encrypted authentication</p>
        </div>
      </div>
    </div>
  );
};

export default AdminLogin;
